import { Moment } from '@e3dc-react/shell/Libs/moment'
import React from 'react'
import { ChartView } from 'src/Libs/chart-kit/shared/utils/chartModel'
import ChartDateSelect from './ChartDateSelect'
import { useSystemChartCallbacks } from '../../../../system-charts/shared/utils/SystemChartUtils'

interface Props {
  from: Moment /** time from which on data should be displayed */
  maxFrom: Moment /** the latest possible date which can be selected from which on to display data */
  to: Moment /** time until which data should be displayed */
  maxTo: Moment /** the latest possible data which can be selected until which data should be displayed */
  minFrom?: string /** earliest timestamp which can be selected regardless of the view */
  customRange: boolean
  hasForecastOption: boolean
  isForecastEnabled?: boolean
  view: ChartView
  setView: (value: ChartView) => void
  setFrom: (value: Moment) => void
  setTo: (value: Moment) => void
  setCustomRange: (value: boolean) => void
  setIsForecastEnabled?: (value: boolean) => void
}

/**
 * Wraps the chart date select component which allows to configure date settings. Handling changing those settings is added here.
 */
const ChartDateBar: React.FC<Props> = ({
  from,
  to,
  customRange,
  hasForecastOption,
  isForecastEnabled = false,
  view,
  maxFrom,
  maxTo,
  minFrom,
  setView,
  setFrom,
  setTo,
  setCustomRange,
  setIsForecastEnabled,
}) => {
  const [handleViewChange, handleFromChange, handleToChange, handleCustomRangeChange, handleMinus, handlePlus, handleShowForecast] =
    useSystemChartCallbacks(
      from,
      to,
      customRange,
      isForecastEnabled,
      view,
      maxFrom,
      maxTo,
      setView,
      setFrom,
      setTo,
      setCustomRange,
      setIsForecastEnabled,
      minFrom
    )

  return (
    <ChartDateSelect
      minFrom={minFrom}
      maxTS={maxTo}
      maxFrom={maxFrom}
      maxTo={maxTo}
      view={view}
      from={from}
      to={to}
      customRange={customRange}
      hasForecastOption={hasForecastOption}
      isForecastEnabled={isForecastEnabled}
      onViewChange={handleViewChange}
      onFromChange={handleFromChange}
      onToChange={handleToChange}
      onCustomRangeChange={handleCustomRangeChange}
      onMinus={handleMinus}
      onPlus={handlePlus}
      onShowForecast={handleShowForecast}
    />
  )
}

export default ChartDateBar
